import React, { useRef, useState, useEffect, useMemo } from "react";
import YouTube from "react-youtube";
import { clickTrackLog } from "../services/clickTrack.service";

export const YouTubePlayer = (props) => {
  const [played, setPlayed] = useState(false);

  const { url, eventId, exhibitorId, clientKey, clickTrack = true } = props;

  const onPlay = () => {
    if (played) return;
    setPlayed(true);
    clickTrackLog(eventId, exhibitorId, clientKey, "YoutubeVideo", url, "Exhibitor");
  };

  const extractIdFromUrl = () => {
    let startString = "";
    if (url.includes("https://www.youtube.com/watch?v=")) {
      startString = "https://www.youtube.com/watch?v=";
      var tempString = url.replace(startString, "");

      return tempString.substring(0, tempString.includes("?") ? tempString.indexOf("?") : tempString.length);
    } else if (url.includes("https://youtu.be/")) {
      startString = "https://youtu.be/";
      var tempString = url.replace(startString, "");
      return tempString.substring(0, tempString.includes("?") ? tempString.indexOf("?") : tempString.length);
    } else if (url.includes("https://www.youtube.com/embed/")) {
      startString = "https://www.youtube.com/embed/";
      var tempString = url.replace(startString, "");

      return tempString.substring(0, tempString.includes("?") ? tempString.indexOf("?") : tempString.length);
    }
  };

  const id = useMemo(() => {
    return extractIdFromUrl();
  }, [url]);

  const opts = {
    height: "100%",
    width: "100%",
    playerVars: {
      autoplay: url.toString().includes("autoplay=1") ? 1 : 0,
    },
  };

  return <YouTube videoId={id} className="yt-video" opts={opts} onPlay={onPlay} />;

  /*  return <iframe width="560" height="315" src={url} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>; */
};
